var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 0 0 16.002A8 8 0 0 0 12 4M2 12C2 6.479 6.478 2 12 2c5.524 0 10.002 4.478 10.002 10 0 5.524-4.478 10.002-10.001 10.002S2 17.524 2 12m10-1a1 1 0 0 1 1 1v3.601a1 1 0 1 1-2 0v-3.6a1 1 0 0 1 1-1m0-3.6a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;